<!-- views/About.vue -->
<template>
  <div class="about-page">
    <Sidebar />
    <div class="main-content">
      <div class="header">
        <div class="navigation">
          <span class="nav-item" @click="router.push('/')">首页</span> /
          <span class="nav-item active">关于我们</span> /
          <span class="nav-item">编辑</span>
        </div>
        <el-button class="view-btn" type="primary" @click="goToDisplay">查看页面</el-button>
      </div>
      <div class="section">
        <RichTextEditor 
          v-model="aboutContent"
          @publish="saveContent"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElNotification } from 'element-plus';
import Sidebar from '../components/Sidebar.vue';
import RichTextEditor from '../components/RichTextEditor.vue';
import { getAboutus, updateAboutUs } from '@/api/api';

const aboutContent = ref('');
const router = useRouter();

const loadContent = async () => {
  try {
    const response = await getAboutus();
    console.log('完整响应:', response);
    aboutContent.value = response.data?.content || '';
  } catch (error) {
    console.error('获取内容失败:', error);
    ElNotification({
      title: '错误',
      message: '加载内容失败，请刷新重试',
      type: 'error',
    });
  }
};

const saveContent = async (content) => {
  try {
    const response = await updateAboutUs({ content });
    console.log('保存响应:', response);
    ElNotification({
      title: '成功',
      message: '内容已保存！',
      type: 'success',
    });
    await loadContent(); // 重新加载确认保存
  } catch (error) {
    console.error('保存失败:', error);
    ElNotification({
      title: '错误',
      message: '保存失败，请稍后重试',
      type: 'error',
    });
  }
};

const goToDisplay = async () => {
  await nextTick(); // 等待 DOM 更新
  router.push('/about?t=' + Date.now());
};

onMounted(loadContent);
</script>

<style scoped>
.about-page {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  padding: 30px;
  margin-left: 200px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 15px 20px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.navigation {
  display: flex;
  gap: 8px;
  font-size: 16px;
}

.nav-item {
  cursor: pointer;
  color: #555;
  transition: color 0.3s ease;
}

.nav-item.active {
  color: #5a9bd4;
  font-weight: 600;
}

.nav-item:hover {
  color: #5a9bd4;
  text-decoration: underline;
}

.view-btn {
  padding: 10px 20px;
}

.section {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}
</style>